exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wallet-choice[data-v-8521fb62] {\n  position: relative;\n}\n.prev[data-v-8521fb62] {\n  left: 0;\n}\n.next[data-v-8521fb62] {\n  right: 0;\n}\n@media (max-width: 450px){\n.history-calendar-box[data-v-8521fb62] {\n    flex-flow: nowrap;\n}\n.calendar-title[data-v-8521fb62] {\n    width: 50px;\n}\n}\n\n", ""]);

// exports
